module.exports = __webpack_public_path__ + "static/media/planta2.b74504b0.png";